var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 17H7A5 5 0 0 1 7 7h4v2H7a3 3 0 1 0 0 6h4v2Zm6-10h-4v2h4a3 3 0 0 1 0 6h-4v2h4a5 5 0 1 0 0-10Zm-1 4H8v2h8v-2Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }